module.exports = __webpack_public_path__ + "img/banners-desktop.68d3763e.jpg";